import { getConfig } from "@/lib/config";
import type { StudioNotebookPdfPayload } from "@/lib/studio-notebook-pdf-model";

// The Studio page and its isolated PDF renderer document talk only through these messages. The renderer has no
// preview: it renders the payload it is sent and hands the file back, and the page saves it.
export type StudioNotebookRendererRequest = { type: "studio-notebook-render"; payload: StudioNotebookPdfPayload };

export type StudioNotebookRendererResponse =
  | { type: "studio-notebook-renderer-ready" }
  | { type: "studio-notebook-pdf"; blob: Blob }
  | { type: "studio-notebook-pdf-failed" };

export function studioNotebookRendererDocumentUrl(): string {
  const basePath = getConfig().basePath;
  return `${basePath.endsWith("/") ? basePath : `${basePath}/`}studio-notebook-renderer.html`;
}

export function isStudioNotebookRendererRequest(data: unknown): data is StudioNotebookRendererRequest {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  return (data as { type: unknown }).type === "studio-notebook-render" && "payload" in data;
}

export function isStudioNotebookRendererResponse(data: unknown): data is StudioNotebookRendererResponse {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  const type = (data as { type: unknown }).type;
  if (type === "studio-notebook-pdf") return (data as { blob?: unknown }).blob instanceof Blob;
  return type === "studio-notebook-renderer-ready" || type === "studio-notebook-pdf-failed";
}
